import Nous from "../containers/Nous/Nous";

const NousPage =  (props) => {

  return <Nous {...props}/>;
};

export async function getStaticProps() {
  const res = await fetch(process.env.API_URL + '/users')
  const users = await res.json()
  
  return {
    props: {
      users
    },
  }
}

export default NousPage;